import { render, staticRenderFns } from "./creditchargesalesWx.vue?vue&type=template&id=3869800b&scoped=true"
import script from "./creditchargesalesWx.vue?vue&type=script&lang=js"
export * from "./creditchargesalesWx.vue?vue&type=script&lang=js"
import style0 from "./creditchargesalesWx.vue?vue&type=style&index=0&id=3869800b&prod&scoped=true&lang=css"
import style1 from "./creditchargesalesWx.vue?vue&type=style&index=1&id=3869800b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3869800b",
  null
  
)

export default component.exports